import React, { useState, useEffect } from 'react';
import Search from './Search';
import { Data, MobileMoreMenuProps } from './Header.types';
import classnames from 'classnames';

const MobileMoreMenu = ({
  data,
  isMenuShown,
  isSubMenuShown,
  setIsSubMenuShown,
  searchBarVisible,
}: MobileMoreMenuProps) => {
  const [subMenuId, setSubMenuId] = useState('');
  const tabValue = isMenuShown && !isSubMenuShown ? undefined : -1;
  const subMenuTabValue = isMenuShown && isSubMenuShown ? undefined : -1;

  const handleSubMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    const element = e.target as HTMLElement;
    if (setIsSubMenuShown) setIsSubMenuShown(!isSubMenuShown);
    if (
      subMenuId &&
      document.getElementById(`${subMenuId}_sub`) &&
      document.getElementById(subMenuId)
    ) {
      // Focus on opening link when sub menu is closed
      document.getElementById(subMenuId)?.focus();
    }
    setSubMenuId(element.id);
    window.scrollTo(0, 0);
  };

  const SubMenu = ({ data, subMenuId }: { data: Data; subMenuId: string }) => {
    let list = data.lists.list1;
    if (subMenuId === 'travelInfo') {
      list = data.lists.list1;
    } else if (subMenuId === 'getAround') {
      list = data.lists.list2;
    } else if (subMenuId === 'quickLinks') {
      list = data.lists.list3;
    }

    useEffect(() => {
      !isMenuShown && setIsSubMenuShown && setIsSubMenuShown(false);
    }, [isMenuShown]);

    useEffect(() => {
      const firstLink = document.querySelector(
        '.tfl-header__sub-menu-back-button'
      ) as HTMLElement;
      isSubMenuShown && firstLink.focus();
    });

    return (
      <div className="tfl-header__panel-inner">
        <button
          onClick={handleSubMenu}
          className="tfl-header__sub-menu-back-button"
          aria-label={`${list.header}, back to main menu`}
          id={`${subMenuId}_sub`}
          tabIndex={subMenuTabValue}
        >
          <span className="tfl-header__sub-menu-header">{list.header}</span>
        </button>
        <ul className="tfl-header__list-container">
          {list.links.map((link, i) => (
            <li className="tfl-header__sub-menu-list-item" key={i}>
              <a
                tabIndex={subMenuTabValue}
                href={link.url}
                className="tfl-header__sub-menu-link"
              >
                {link.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <>
      <div className="tfl-header__more-menu-mobile">
        {searchBarVisible && (
          <Search
            isMenuShown={isMenuShown}
            isSubMenuShown={isSubMenuShown}
            isSmallScreen={true}
          />
        )}
        <ul className="tfl-header__list-container tfl-header__mobile-top-nav">
          {data?.lists.topNav.links.map((link, i) => (
            <li className="tfl-header__mobile-top-nav-list-item" key={i}>
              <a
                tabIndex={tabValue}
                href={link.url}
                className="tfl-header__mobile-top-nav-link"
              >
                {link.text}
              </a>
            </li>
          ))}
        </ul>
        <ul className="tfl-header__list-container tfl-header__mobile-sub-menu-list">
          <li>
            <button
              className="tfl-header__open-sub-menu-button"
              onClick={handleSubMenu}
              id="travelInfo"
              tabIndex={tabValue}
            >
              {data?.lists.list1.header}
            </button>
          </li>
          <li>
            <button
              className="tfl-header__open-sub-menu-button"
              onClick={handleSubMenu}
              id="getAround"
              tabIndex={tabValue}
            >
              {data?.lists.list2.header}
            </button>
          </li>
          <li>
            <button
              className="tfl-header__open-sub-menu-button"
              onClick={handleSubMenu}
              id="quickLinks"
              tabIndex={tabValue}
            >
              {data?.lists.list3.header}
            </button>
          </li>
        </ul>
        <div
          className={classnames([
            'tfl-header__mobile-sub-menu-panel',
            `tfl-header__mobile-sub-menu-panel--${
              isMenuShown && isSubMenuShown ? 'shown' : 'hidden'
            }`,
          ])}
        >
          <SubMenu data={data as Data} subMenuId={subMenuId} />
        </div>
      </div>
    </>
  );
};

export default MobileMoreMenu;
